"use client";

import * as React from "react";
import { cn } from "@/utils";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "simple";
  iconOnly?: boolean;
  className?: string;
  contentClassName?: string;
  children: React.ReactNode;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant = "primary",
      iconOnly,
      className,
      contentClassName,
      children,
      ...rest
    },
    ref,
  ) => {
    const isSimple = variant === "simple";

    return (
      <button
        ref={ref}
        type="button"
        {...rest}
        className={cn(
          "group relative disabled:pointer-events-none disabled:opacity-60",
          className,
        )}
      >
        {!isSimple && (
          <span
            aria-hidden
            className="absolute -inset-px rounded-full hex-gradient opacity-0 blur-[1px] transition-opacity duration-300 group-hover:opacity-100"
          />
        )}
        <span
          className={cn(
            "relative z-10 inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all duration-200",
            isSimple
              ? "rounded-lg border border-white/10 bg-surface-300 px-3 py-1.5 text-foreground hover:bg-surface-400 hover:text-white"
              : "rounded-full border border-white/10 bg-surface-300 px-5 py-2.5 text-white hover:bg-surface-400",
            iconOnly && "!px-2.5",
            contentClassName,
          )}
        >
          {children}
        </span>
      </button>
    );
  },
);

Button.displayName = "Button";

export default Button;
